import muster from '@dbk-legacy/muster';
import { watchValues } from '@dbk-legacy/muster/utils';

export default () =>
  muster()
    .match('debug.*', {
      get(requests, { get }) {
        const paths = requests.map(
          ({ req }) => req.path.replace('debug.', '')
        );
        return watchValues(get(['ui.debug']))
          .switchMap(([isDebugActive]) =>
            get(paths).map((pathValues) => pathValues.map(({ path, value }) =>
              ({ path: `debug.${path}`, value: isDebugActive ? undefined : value })
            ))
          );
      },
    });
